import { FinancingProcessFilterCriteria } from 'shared';

const localStorageUtils = {
  set: (key: string, value: number | string) => {
    const parseValue = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, parseValue);
    return value;
  },
  get: (key: string) => {
    const value = localStorage.getItem(key);
    return value;
  },
  remove: (key: string) => localStorage.removeItem(key),
  clearFinancingProcessFilterCriteria: () => {
    Object.keys(FinancingProcessFilterCriteria).forEach(filterCriteriaKey => {
      localStorage.removeItem(filterCriteriaKey);
    });
  }
};

export { localStorageUtils };
